import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)
import wxConfig from '@/utils/wxConfig'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout'

export const constantRouterMap = [
  {
    path: '/wechat',
    component: _import('wechat/index'),
    hidden: true
  },
  {
    path: '/login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/write-off/order/:orderId',
    name: 'WriteOffOrderDetail',
    component: _import('write-off/WriteOffOrderDetail'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'orders',
        component: _import('orders/index'),
        name: 'Orders'
      },
      {
        path: 'customers',
        component: _import('customers/index'),
        name: 'Customers'
      },
      {
        path: 'person',
        component: _import('person/index'),
        name: 'Person'
      }
    ]
  },
  {
    path: '/order-detail/:orderId',
    component: _import('orders/components/OrderDetail'),
    name: 'OrderDetail'
  },
  {
    path: '/customer-detail/:customerId',
    component: _import('customers/components/CustomerDetail'),
    name: 'CustomerDetail'
  },
  {
    path: '/customer-credit/:creditsId',
    component: _import('customers/components/CustomerCredit'),
    name: 'CustomerCredit'
  },
  {
    path: '/search',
    component: _import('search/index'),
    name: 'Search'
  },
  {
    path: '/customer-search',
    component: _import('search/CustomersSearch'),
    name: 'CustomersSearch'
  },
  {
    path: '/order-check/:orderId',
    component: _import('orders/components/OrderCheck'),
    name: 'OrderCheck'
  }
]

// 创建router实例，设置路由等参数
const router = new Router({
  mode: 'history',
  routes: constantRouterMap
})

// router.beforeEach((to, from, next) => {
//   // ...
//   wxConfig.asyncConfig().then(next())
// })

router.afterEach((to, from) => {
  wxConfig.asyncConfig(to.fullPath)
})

export default router
